// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuefire from 'vuefire'
import App from './App'
import router from './router'
import firebase from 'firebase'
import VueMaterial from 'vue-material'
import Vuex from 'vuex'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import '@/services/firebase'
import VueResource from 'vue-resource'
import store from '@/store'

Vue.use(Vuefire)
Vue.use(VueResource)
Vue.use(VueMaterial)
Vue.use(Vuex)

Vue.config.productionTip = false

let app
firebase.auth().onAuthStateChanged(function (user) {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      el: '#app',
      router,
      store,
      template: '<App/>',
      components: { App }
    })
  }
})

Vue.filter('readableTime', function (t) {
  var a = new Date(t * 1000)
  var today = new Date()
  var yesterday = new Date(Date.now() - 86400000)
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var year = a.getFullYear()
  var month = months[a.getMonth()]
  var date = a.getDate()
  var hour = a.getHours() > 12 ? a.getHours() - 12 : a.getHours()
  if (hour === 0) {
    hour = '12'
  }
  var min = ('0' + a.getMinutes()).slice(-2)
  var amPm = a.getHours() >= 12 ? 'PM' : 'AM'
  if (a.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0)) {
    return 'Today, ' + hour + ':' + min + ' ' + amPm
  } else if (a.setHours(0, 0, 0, 0) === yesterday.setHours(0, 0, 0, 0)) {
    return 'Yesterday, ' + hour + ':' + min + ' ' + amPm
  } else if (year === today.getFullYear()) {
    return month + ' ' + date + ', ' + hour + ':' + min + ' ' + amPm
  } else {
    return month + ' ' + date + ' ' + year + ', ' + hour + ':' + min + ' ' + amPm
  }
})



// WEBPACK FOOTER //
// ./src/main.js